import { useCallback } from 'preact/hooks';

import { usePlayer } from './PlayerProvider';

export const useVolume = () => {
  const player = usePlayer();

  const adjustVolume = useCallback(
    (amount: number) => {
      const jw = player.getJWPlayer();
      if (!jw) {
        return;
      }

      const volume = jw.getVolume();

      const newVolume = Math.min(100, Math.max(0, volume + amount));

      jw.setVolume(newVolume);
    },
    [player]
  );

  return { adjustVolume };
};
